import YoutubePlayerWrapper from '../../../utils/youtube-video';

export default class XLTileBgYouTubePlayer {
    constructor(el) {
        this.el = el.querySelector('.xl-tile-lite-bg-yt-video');
        this.player = new YoutubePlayerWrapper(this.el, { isBgVideo: true });
        this.bind();
    }

    bind() {
        const instance = this.player.getPlayerInstance();
        instance.addEventListener('ready', this.el.dispatchEvent(new CustomEvent('YoutubeBGLoaded')));
    }
}
